import { Check } from "@neonumy/neonumy-icons";
import { Button } from "@neonumy/neonumy-ui";
import { Col, Form, FormInstance, Row, Space, Spin } from "antd5";
import PageTitle from "components/PageTitle";
import { useTranslation } from "react-i18next";
import { useUserForm } from "./hooks/useUserForm";
import NewUserWorkSettigs from "./NewUserWorkSettings";
import SettingsUserNewrai from "./SettingsUserNewrai";
import UserDetails from "./UserDetails";

interface UserFormPropsType {
  userId: ID;
  /** Only needed by callers that submit the form themselves, such as the `AddUser` wizard. */
  form?: FormInstance<CollaboratorFormValues>;
  onFinish?: (newUserId: ID) => void;
}

export default function UserForm({ userId, form: formProp, onFinish }: UserFormPropsType) {
  const { t } = useTranslation();
  const [internalForm] = Form.useForm<CollaboratorFormValues>();
  const form = formProp ?? internalForm;

  const {
    isEdit,
    applicationGroups,
    isNewraiUser,
    getUserLoading,
    createUpdateUserLoading,
    userIsClient,
    canAddOrUpdateUser,
    workShiftChoices,
    hideApplicationGroupsInput,
    showCanUseBlockedSsiAccounts,
    onFinishForm,
    onValuesChange,
  } = useUserForm({ userId, form, onFinish });

  return (
    <>
      <PageTitle className="form-width" title={isEdit ? t("Edit user") : t("Create user")} />
      <Spin spinning={getUserLoading}>
        <Space direction="vertical" size="large" className="width-100">
          <Form
            className="form-width form-sections"
            layout="vertical"
            form={form}
            onFinish={onFinishForm}
            autoComplete="off"
            onValuesChange={onValuesChange}
          >
            <UserDetails
              userIsClient={userIsClient}
              applicationGroupsOptions={applicationGroups}
              disabled={!canAddOrUpdateUser}
              hideApplicationGroupsInput={hideApplicationGroupsInput}
            />
            {!isEdit && (
              <NewUserWorkSettigs
                workShiftOptions={workShiftChoices}
                disabled={!canAddOrUpdateUser}
                isNewraiUser={!!isNewraiUser}
              />
            )}
            {isNewraiUser && (
              <SettingsUserNewrai
                workShiftOptions={workShiftChoices}
                disabled={!canAddOrUpdateUser}
                showCanUseBlockedSsiAccounts={showCanUseBlockedSsiAccounts}
              />
            )}
            {isEdit && canAddOrUpdateUser && (
              <Row justify="end">
                <Col>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={createUpdateUserLoading}
                    icon={<Check />}
                    iconPosition="start"
                  >
                    {t("Save")}
                  </Button>
                </Col>
              </Row>
            )}
          </Form>
        </Space>
      </Spin>
    </>
  );
}
